import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestResultService = ( createDecorator('testResultService'));
export { ITestResultService };
